const message = {
  HOTQUESTIONS: "Hot Questions",
  Q1: "Do you want to consult the following?",
  TELLMEREASON:
    "Can you please share your reason so I can improve in the future?",
  VIEWALL: "View all",
  MYHOMEPAGE: "My homepage",
  RECOGNITION: "Thank you for your recognition.",
  IWANTTOASK: "I want to ask...",
  YOUMAYASK: "You may ask:",
  FAQLIST: "FAQ List",
  HOT: "Hot",
  AllAPPLICATIONS: "All applications",
  MORE: "More",
  FEEDBACKMSG: "Your feedback is well-received. We will continuously improve.",
  MORESKILL: "More Skill",
  GREETING: "Hi，%s，I'm %s，%s",
  FEEDBACK: "Submit Feedback",
};

export default message;
